import { Injectable } from "@angular/core";

import { HttpService, Lookup, HttpServiceBaseCRUD, GetPagedBody } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class ProductCategoriesService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "producttypes/";
  }

  add(category: Omit<Lookup, "id">) {
    return this.post<Lookup>({ APIName: "add", body: category });
  }

  update(category: Lookup) {
    return this.put<Lookup>({ APIName: "update", body: category });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<Lookup>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Lookup>) {
    return this.getPagedRequest<Lookup[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<Lookup[]>({ APIName: "getall" });
  }
}
